import axios from "axios"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { getId, getToken, usePermissions } from "../../user/User"
import BasicTableComponent, { NumberRangeColumnFilter } from "../../components/basic.table"
import { toast } from "react-toastify"

const SectorList = () => {
    const navigate = useNavigate()

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.sector !== undefined && !permissions.sector) {
            toast.error("You don't have permission to view sectors!")
            navigate("/")
        }
    }, [permissions])

    const handleCreate = async e => {
        e.preventDefault(),
        navigate("/sector/create")
    }

    const columns =  [{
        Header: "Edit",
        UrlPart: "sector"
    }, {
        Header: "Delete",
        UrlPart: "sector/delete"
    }, {
        Header: "Id",
        accessor: "id",
        Filter: NumberRangeColumnFilter,
        filter: 'between'
    }, {
        Header: "Name",
        accessor: "name"
    }]

    const [sectors, setSectors] = useState([])

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "/api/sectors", {
            headers: {
                "Authorization": "Bearer " + getToken()
            }
        })
        .then(res => {
            if(res.data === null || res.data === "") {
                return
            }
            setSectors(res.data)
        }).catch(_ => {
            toast.error("Unable to load sectors!")
        })
    }, [])

    return (
        <div>
            <button className="btn btn-primary" onClick={handleCreate}>Create sector</button>
            <br /><br />

            <BasicTableComponent columns={columns} data={sectors} />
        </div>
    )
}

export default SectorList
